import { useEffect, useState } from 'react';

export function useShowScrollArrowOnContainer(
  containerRef: React.RefObject<HTMLElement | null>
) {
  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    const check = () => {
      const el = containerRef.current;
      if (!el) return;

      const scrollHeight = el.scrollHeight;
      const scrollTop = el.scrollTop;
      const clientHeight = el.clientHeight;

      if (scrollTop + clientHeight < scrollHeight - 10) {
        setShowArrow(true);
      } else {
        setShowArrow(false);
      }
    };

    const el = containerRef.current;
    if (!el) return;

    check();

    el.addEventListener('scroll', check);
    window.addEventListener('resize', check);

    const observer = new MutationObserver(() => {
      check();
    });

    observer.observe(el, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true
    });

    return () => {
      el.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      observer.disconnect();
    };
  }, [containerRef]);

  return showArrow;
}
